import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-357f62e0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "goods_details"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1));

const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "规格设置", -1));

const _hoisted_7 = {
  class: "content"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, [/*#__PURE__*/_createTextVNode("规格设置"), /*#__PURE__*/_createElementVNode("b")], -1));

const _hoisted_9 = {
  class: "base_details_content_second"
};
const _hoisted_10 = {
  class: "base_details_title_button"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tb_title"
}, [/*#__PURE__*/_createTextVNode("SKU管理"), /*#__PURE__*/_createElementVNode("b")], -1));

const _hoisted_12 = {
  class: "base_details_content_second"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "赠送设置", -1));

const _hoisted_14 = {
  class: "content"
};
const _hoisted_15 = {
  class: "content"
};
const _hoisted_16 = {
  class: "base_screen_header"
};
const _hoisted_17 = {
  class: "dialog-footer"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_screen_header"
}, null, -1));

const _hoisted_19 = {
  class: "dialog-footer"
};
import BackTitleView from "@com/BackTitleView.vue";
import GoodsSpecs from "@com/goods/GoodsSpecs.vue";
import UploadPicture from "@com/upload/UploadPicture.vue";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { ref, reactive } from "vue";
import $ from "@util/base";
import { $msg, $box } from "@/common/ui/msg";
import useRoute from "@util/router"; // import testSkuData from "@/test/skuData.json"

import UploadSinglePicture from "@com/upload/UploadSinglePicture.vue";
import goodsConfigApi from "@api/goodsConfig";
import api from "@api/goods";
import { Search } from "@element-plus/icons-vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@/components/table/tableOperations";
import couponApi from "@/api/coupon";
import tagsApi from "@/api/memberGrade";
const aaa = "value=value.replace('-', '')";
export default {
  __name: 'GoodsDetails',

  setup(__props) {
    const attrFieldName = ref("");
    const specsData = ref({
      skuSaleAttr1: null,
      skuSaleAttr2: null,
      skuSaleAttr1Value: [],
      skuSaleAttr2Value: []
    });
    const skuData = ref([]);
    const route = useRoute();
    const activeName = ref("basic");
    const deliverOptions = [{
      label: "快递",
      value: "1045002"
    }, {
      label: "自提",
      value: "1045003"
    }, {
      label: "快递和自提",
      value: "1045001"
    }];

    function clearNoNum(obj) {
      obj.value = obj.value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符

      obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的

      obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj.value = obj.value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数

      if (obj.value.indexOf(".") < 0 && obj.value != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        obj.value = parseFloat(obj.value);
      }
    }

    function tabChange(active) {
      // if (active == "spec") {
      //   basicFormRef.value.validate((valid, fields) => {
      //     if (valid && checkUnit()) {
      //       activeName.value = active;
      //     }
      //   });
      // } else {
      activeName.value = active; // }
    }

    const urlQuery = route.query();
    var readOnly = false;
    var isModify = false;
    var isApproval = false;
    var title = "邮费模板详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "商品详情";
        getData();
      },
      add: () => {
        title = "新增商品";
      },
      modify: () => {
        title = "修改商品";
        isModify = true;
        getData();
      },
      examine: () => {
        readOnly = true;
        isApproval = true;
        title = "商品详情";
        getData();
      }
    });
    const typeOptions = ref([]); // const baseOptions = ref([])

    const postageOptions = ref([]);
    const specsOptions = ref([]);
    const labelOptions = ref([]);
    const stationOptions = ref([]);
    getConfig();

    function getConfig() {
      goodsConfigApi.category(val => {
        typeOptions.value = val;
      }); // goodsConfigApi.base(val => { baseOptions.value = val })

      goodsConfigApi.express(val => {
        postageOptions.value = val;
      });
      goodsConfigApi.goodsSpecs(val => {
        specsOptions.value = val;
      });
      goodsConfigApi.label(val => {
        labelOptions.value = val;
      });
      goodsConfigApi.station(val => {
        stationOptions.value = val;
      });
    }

    const otherUnit = ref();
    const unitOptions = ["个", "份", "箱", "其他"];
    const goodsSpecs = ref(null);
    const basicFormRef = ref(null);
    const basicForm = reactive({
      id: null,
      productCode: null,
      categoryCode: null,
      productName: null,
      // shopCode: null,
      limitDeliveryType: null,
      sellUnit: null,
      postageTempleteCode: null,
      stationIds: [],
      tags: null,
      maxBuy: null,
      minBuy: 1,
      mainPic: [],
      descList: [],
      picList: [],
      flowStatus: null,
      flowCode: null,
      payType: '',
      payTypeList: ['1021001', '1021002'],
      couponItemList: [],
      tagsItemList: []
    });
    const basicRules = {
      categoryCode: [{
        required: true,
        message: "请选择商品分类",
        trigger: "change"
      }],
      limitDeliveryType: [{
        required: true,
        message: "请选择发货方式",
        trigger: "blur"
      }],
      productName: [{
        required: true,
        message: "请输入商品名称",
        trigger: "blur"
      }],
      // shopCode: [{
      //   required: true,
      //   message: '请选择归属基地',
      //   trigger: 'change',
      // }],
      picList: [{
        required: true,
        type: "array",
        message: "请上传商品封面",
        trigger: "change"
      }],
      descList: [{
        required: true,
        type: "array",
        message: "请上传商品简介",
        trigger: "change"
      }],
      mainPic: [{
        required: true,
        type: "array",
        message: "请上传商品主图",
        trigger: "change"
      }],
      sellUnit: [{
        required: true,
        message: "请选择商品单位",
        trigger: "change"
      }],
      postageTempleteCode: [{
        required: true,
        message: "请选择邮费模板",
        trigger: "change"
      }],
      stationIds: [{
        required: true,
        type: "array",
        message: "请选择可选自提点",
        trigger: "change"
      }],
      minBuy: [{
        required: true,
        message: "请输入起购数量",
        trigger: "blur"
      }, {
        type: "number",
        min: 1,
        message: "起购数量最小值为1",
        trigger: "blur"
      }],
      payTypeList: [{
        required: true,
        message: '请选择支付方式',
        trigger: 'change'
      }]
    };

    function getData() {
      api.details(route.query().code, val => {
        basicForm.id = val.id;
        basicForm.categoryCode = val.categoryCode;
        basicForm.productName = val.productName; // basicForm.shopCode = val.shopCode

        basicForm.postageTempleteCode = val.postageTempleteCode;
        basicForm.limitDeliveryType = val.limitDeliveryType;
        basicForm.stationIds = val.stationIds;
        basicForm.tags = parseInt(val.tags);
        basicForm.maxBuy = val.maxBuy;
        basicForm.minBuy = val.minBuy;
        basicForm.mainPic = [val.mainPic];
        basicForm.descList = val.descList;
        basicForm.picList = val.picList;
        basicForm.flowStatus = val.flowStatus;
        basicForm.flowCode = val.flowCode;
        basicForm.couponItemList = val.couponItemList;
        basicForm.tagsItemList = val.tagsItemList;

        if (unitOptions.includes(val.sellUnit)) {
          basicForm.sellUnit = val.sellUnit;
        } else {
          basicForm.sellUnit = "其他";
          otherUnit.value = val.sellUnit;
        }

        if ($.isNotEmpty(val.payType)) {
          basicForm.payTypeList = val.payType.split(",");
        }

        let sku = val.sku;
        attrFieldName.value = sku.attrName;
        specsData.value = {
          skuSaleAttr1: sku.skuSaleAttr1,
          skuSaleAttr2: sku.skuSaleAttr2,
          skuSaleAttr1Value: sku.skuSaleAttr1Value,
          skuSaleAttr2Value: sku.skuSaleAttr2Value
        };
        skuData.value = sku.itemList;
      });
    }

    function generateSKU() {
      basicFormRef.value.validate((valid, fields) => {
        if (valid && checkUnit()) {
          let specsData = goodsSpecs.value.getValue();

          if (specsData != false) {
            let goodsData = $.deepCopy(basicForm);

            if (goodsData.limitDeliveryType === "1045002") {
              goodsData.stationIds = [];
            } else if (goodsData.limitDeliveryType === "1045003") {
              goodsData.postageTempleteCode = null;
            }

            goodsData.sellUnit = getUnit();
            goodsData.specs = specsData;

            if ($.isNotEmpty(goodsData.mainPic)) {
              goodsData.mainPic = goodsData.mainPic.join(",");
            }

            if ($.isNotEmpty(goodsData.payTypeList)) {
              goodsData.payType = goodsData.payTypeList.join(",");
            }

            if ($.isNotEmpty(goodsData.couponItemList)) {
              goodsData.couponItemList = goodsData.couponItemList.map((e, index) => {
                e.sort = e.sort || index + 1;
                return e;
              });
            }

            api.generateSKU(goodsData, val => {
              basicForm.productCode = val.productCode;
              attrFieldName.value = val.attrName;
              skuData.value = val.itemList;
            });
          }
        } else {
          $msg.error("请完善基本信息");
        }
      });
    }

    function getUnit() {
      if (basicForm.sellUnit != "其他") {
        return basicForm.sellUnit;
      } else {
        return otherUnit.value;
      }
    }

    function checkUnit() {
      if (basicForm.sellUnit == "其他" && $.isEmpty(otherUnit.value)) {
        $msg.error("请输入单位");
        return false;
      }

      return true;
    }

    function checkSKU() {
      if ($.isEmpty(skuData.value)) {
        $msg.error("请生成SKU");
        return false;
      }

      for (const item of skuData.value) {
        //1 有效、 0 无效
        if (item.flag == 1) {
          for (const key in item) {
            if ($.isEmpty(item[key])) {
              $msg.error("请完善SKU数据");
              return false;
            }
          }
        }
      }

      return true;
    }

    function save(isExamine) {
      basicFormRef.value.validate((valid, fields) => {
        if (valid && checkUnit()) {
          if (checkSKU()) {
            $.handleCRU(route.query().type, {
              add: () => {
                skuSubmit(isExamine);
              },
              modify: () => {
                updateSKUSubmit(isExamine);
              }
            });
          }
        } else {
          $msg.error("请完善基本信息");
        }
      });
    }

    function skuSubmit(isExamine) {
      api.skuSubmit({
        productCode: basicForm.productCode,
        // shopCode: basicForm.shopCode,
        itemList: skuData.value,
        isExamine: isExamine,
        couponItemList: basicForm.couponItemList,
        tagsItemList: basicForm.tagsItemList
      }, () => {
        $msg.succ("保存成功");
        route.go(-1);
      });
    }

    function updateSKUSubmit(isExamine) {
      basicFormRef.value.validate((valid, fields) => {
        if (valid && checkUnit()) {
          let goodsData = $.deepCopy(basicForm);

          if ($.isNotEmpty(goodsData.payTypeList)) {
            goodsData.payType = goodsData.payTypeList.join(",");
          }

          if (goodsData.limitDeliveryType === "1045002") {
            goodsData.stationIds = [];
          } else if (goodsData.limitDeliveryType === "1045003") {
            goodsData.postageTempleteCode = null;
          }

          if ($.isNotEmpty(goodsData.mainPic)) {
            goodsData.mainPic = goodsData.mainPic.join(",");
          }

          goodsData.sellUnit = getUnit();
          goodsData.sku = {
            productCode: basicForm.productCode,
            // shopCode: basicForm.shopCode,
            itemList: skuData.value,
            isExamine: isExamine
          };
          api.updateSKUSubmit(goodsData, () => {
            $msg.succ("修改成功");
            route.go(-1);
          });
        } else {
          $msg.error("请完善基本信息");
        }
      });
    }

    function skuEnableStateChange(evt, index) {
      let data = skuData.value[index];

      if ($.isNotEmpty(data.skuCode)) {
        // 1 有效、 0 无效
        if (evt == 1) {
          for (const key in data) {
            if ($.isEmpty(data[key])) {
              $msg.error("请完善SKU数据");
              data.flag = 0;
              return;
            }
          }
        }

        api.skuFlagUpdata(data.skuCode, evt, () => {
          $msg.succ("操作成功");
        }, () => {
          data.flag = evt == 1 ? 0 : 1;
        });
      }
    } // 审批通过


    function approvalPass() {
      $box.open("通过", "确认该商品审批通过", () => {
        api.approval(basicForm.flowCode, "1007004", "", () => {
          $msg.succ("审批成功");
          route.go(-1);
        });
      });
    } // 驳回


    function approvalRefusal() {
      $box.input("确认驳回", "驳回原因", null, val => {
        api.approval(basicForm.flowCode, "1007003", val, () => {
          $msg.succ("驳回成功");
          route.go(-1);
        });
      });
    }

    const addCouponDialog = ref(false);
    const couponName = ref("");
    const couponDataTableRef = ref(null);
    const couponData = ref([]);
    const couponDataConfig = ref({
      showIndex: true,
      showSelection: true,
      column: [{
        label: "名称",
        prop: "name",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "当前状态",
        prop: "enableStatusName",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });
    const couponDataSize = ref(10);
    const couponDataPage = ref(1);
    const couponDataTotal = ref(0);
    const couponDataHandler = operationsHander();
    const couponItemListHandler = operationsHander();
    const couponItemListConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getOperations
      },
      column: [{
        label: "数量",
        prop: "num",
        type: COLUMN_TYPE.input,
        operationsKey: OPERATIONS.input,
        width: 100
      }, {
        label: "名称",
        prop: "couponName",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });
    const addTagsDialog = ref(false);
    const tagsDataTableRef = ref(null);
    const tagsData = ref([]);
    const tagsDataHandler = operationsHander();
    const tagsDataConfig = ref({
      showIndex: true,
      showSelection: true,
      column: [{
        label: "名称",
        prop: "name"
      }, {
        label: "权益",
        prop: "mrpInstall"
      }]
    });
    const tagsItemListHandler = operationsHander();
    const tagsItemListConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getOperations2
      },
      column: [{
        label: "编码",
        prop: "tagsCode"
      }, {
        label: "名称",
        prop: "name"
      }, {
        label: "有效期(天)",
        prop: "num",
        type: COLUMN_TYPE.input,
        operationsKey: OPERATIONS.input
      }]
    });

    function getOperations(data) {
      return [OPERATIONS.del];
    }

    function getOperations2(data) {
      return [OPERATIONS.del2];
    }

    tagsItemListHandler.install(OP_KEY.delete2, (data, row) => {
      $box.open("移除", "确认移除标签：" + data.name, () => {
        let index = basicForm.value.tagsItemList.findIndex(e => {
          return e.code === data.code;
        });
        basicForm.value.tagsItemList.splice(index, 1);
      });
    });
    couponItemListHandler.install(OP_KEY.delete, (data, row) => {
      $box.open("移除", "确认移除优惠券：" + data.couponName, () => {
        let index = basicForm.couponItemList.findIndex(e => {
          return e.couponCode === data.couponCode;
        });
        basicForm.couponItemList.splice(index, 1);
      });
    });

    function showAddTagsDialog() {
      getTagsData();
      addTagsDialog.value = true;
    }

    function getTagsData() {
      tagsApi.list({}, val => {
        tagsData.value = val.itemList;
      });
    }

    function showAddCouponDialog() {
      getCouponData();
      addCouponDialog.value = true;
    }

    function getCouponData() {
      couponApi.list({
        name: couponName.value,
        page: couponDataPage.value,
        size: couponDataSize.value
      }, val => {
        couponData.value = val.list;
        couponDataTotal.value = val.total;
      });
    }

    function couponDataPageChange(type, val) {
      if (type == 'page') {
        couponDataPage.value = val;
      } else if (type == 'size') {
        couponDataSize.value = val;
      }

      getCouponData();
    }

    function tagsDataSelectedSubmit() {
      let selected = tagsDataTableRef.value.getSelectData();

      if ($.isEmpty(selected)) {
        $msg.error("请选择标签");
        return;
      } else {
        selected = selected.filter(f => {
          return !basicForm.tagsItemList.some(s => {
            return s.tagsCode === f.code;
          });
        }).map(e => {
          console.log("e=====" + JSON.stringify(e));
          return {
            tagsCode: e.code,
            name: e.name,
            sort: e.id,
            num: 1
          };
        });
        basicForm.tagsItemList = basicForm.tagsItemList.concat(selected);
        addTagsDialog.value = false;
      }
    }

    function couponDataSelectedSubmit() {
      let selected = couponDataTableRef.value.getSelectData();

      if ($.isEmpty(selected)) {
        $msg.error("请选择优惠券");
        return;
      } else {
        selected = selected.filter(f => {
          return !basicForm.couponItemList.some(s => {
            return s.couponCode === f.couponCode;
          });
        }).map(e => {
          return {
            couponCode: e.couponCode,
            couponName: e.name,
            provideNum: e.provideNum,
            usedNum: e.usedNum,
            lifespan: e.lifespan,
            couponDesc: e.couponDesc,
            createTime: e.createTime,
            creator: e.creator,
            sort: e.sort,
            num: 1
          };
        });
        basicForm.couponItemList = basicForm.couponItemList.concat(selected);
        addCouponDialog.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => activeName.value = $event),
            type: "border-card",
            class: "base_details_tabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              name: "basic"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
                ref_key: "basicFormRef",
                ref: basicFormRef,
                model: basicForm,
                disabled: _unref(readOnly),
                rules: basicRules,
                "label-width": "100px",
                class: "base_details_form"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "商品分类",
                  prop: "categoryCode"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.categoryCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => basicForm.categoryCode = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "发货方式",
                  prop: "limitDeliveryType"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: basicForm.limitDeliveryType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => basicForm.limitDeliveryType = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(deliverOptions, (item, index) => {
                      return _createVNode(_component_el_radio, {
                        key: index,
                        label: item.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "商品名称",
                  prop: "productName"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.productName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => basicForm.productName = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "商品主图",
                  prop: "mainPic"
                }, {
                  default: _withCtx(() => [_createVNode(UploadPicture, {
                    modelValue: basicForm.mainPic,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => basicForm.mainPic = $event),
                    limit: 1,
                    imgSize: '750x*',
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "商品封面",
                  prop: "picList"
                }, {
                  default: _withCtx(() => [_createVNode(UploadPicture, {
                    modelValue: basicForm.picList,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => basicForm.picList = $event),
                    limit: 10,
                    imgSize: _unref($).describeImgSize(),
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "imgSize", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "商品简介",
                  prop: "descList"
                }, {
                  default: _withCtx(() => [_createVNode(UploadPicture, {
                    modelValue: basicForm.descList,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => basicForm.descList = $event),
                    limit: 50,
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "商品单位",
                  prop: "sellUnit"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: basicForm.sellUnit,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => basicForm.sellUnit = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(unitOptions, (item, index) => {
                      return _createVNode(_component_el_radio, {
                        key: index,
                        label: item
                      }, null, 8, ["label"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"]), _createVNode(_component_el_input, {
                    class: "unit_input",
                    modelValue: otherUnit.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => otherUnit.value = $event),
                    placeholder: "单位"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), basicForm.limitDeliveryType != '1045003' ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "邮费模板",
                  prop: "postageTempleteCode"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.postageTempleteCode,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => basicForm.postageTempleteCode = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postageOptions.value, item => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })) : _createCommentVNode("", true), basicForm.limitDeliveryType != '1045002' ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "可选自提点",
                  prop: "stationIds"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.stationIds,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => basicForm.stationIds = $event),
                    multiple: "",
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stationOptions.value, item => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
                  label: "产品标签"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: basicForm.tags,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => basicForm.tags = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labelOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_radio, {
                        key: index,
                        label: item.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "限购数量"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.maxBuy,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => basicForm.maxBuy = $event),
                    type: "number",
                    onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
                    placeholder: "请输入（不输入则表示不限购）"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "起购数量",
                  prop: "minBuy"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.minBuy,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => basicForm.minBuy = $event),
                    modelModifiers: {
                      number: true
                    },
                    type: "number",
                    onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "支付方式",
                  prop: "payTypeList"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                    modelValue: basicForm.payTypeList,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => basicForm.payTypeList = $event)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                      label: "1021001"
                    }, {
                      default: _withCtx(() => [_createTextVNode("微信支付")]),
                      _: 1
                    }), _createVNode(_component_el_checkbox, {
                      label: "1021002"
                    }, {
                      default: _withCtx(() => [_createTextVNode("储值卡支付")]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["model", "disabled"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "spec"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(GoodsSpecs, {
                ref_key: "goodsSpecs",
                ref: goodsSpecs,
                specs: specsOptions.value,
                data: specsData.value,
                readOnly: _unref(readOnly),
                isModify: _unref(isModify)
              }, null, 8, ["specs", "data", "readOnly", "isModify"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, !_unref(readOnly) ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[14] || (_cache[14] = $event => generateSKU())
              }, {
                default: _withCtx(() => [_createTextVNode("生成SKU")]),
                _: 1
              })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_table, {
                data: skuData.value,
                border: "",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  label: attrFieldName.value,
                  prop: "attrDetail",
                  align: "center",
                  width: "140"
                }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
                  label: "SKU编号",
                  prop: "skuCode",
                  align: "center"
                }), _createVNode(_component_el_table_column, {
                  label: "SKU图片",
                  align: "center",
                  width: "120"
                }, {
                  default: _withCtx(scope => [_createVNode(UploadSinglePicture, {
                    modelValue: scope.row.skuPic,
                    "onUpdate:modelValue": $event => scope.row.skuPic = $event,
                    width: 100,
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  label: "库存",
                  prop: "stockNum",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_input, {
                    type: "number",
                    modelValue: scope.row.stockNum,
                    "onUpdate:modelValue": $event => scope.row.stockNum = $event,
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "请输入",
                    disabled: _unref(readOnly),
                    onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  label: "成本价(元)",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                    modelValue: scope.row.costPrice,
                    "onUpdate:modelValue": $event => scope.row.costPrice = $event,
                    modelModifiers: {
                      number: true
                    },
                    min: 0,
                    precision: 2,
                    disabled: _unref(readOnly),
                    controls: false,
                    "controls-position": "right"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  label: "同行价(元)",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                    modelValue: scope.row.competitorPrice,
                    "onUpdate:modelValue": $event => scope.row.competitorPrice = $event,
                    modelModifiers: {
                      number: true
                    },
                    min: 0,
                    precision: 2,
                    disabled: _unref(readOnly),
                    controls: false,
                    "controls-position": "right"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  label: "销售价(元)",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                    modelValue: scope.row.sellPrice,
                    "onUpdate:modelValue": $event => scope.row.sellPrice = $event,
                    modelModifiers: {
                      number: true
                    },
                    min: 0,
                    precision: 2,
                    disabled: _unref(readOnly),
                    controls: false,
                    "controls-position": "right"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  label: "划线价(元)",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                    modelValue: scope.row.markingPrice,
                    "onUpdate:modelValue": $event => scope.row.markingPrice = $event,
                    modelModifiers: {
                      number: true
                    },
                    min: 0,
                    precision: 2,
                    disabled: _unref(readOnly),
                    controls: false,
                    "controls-position": "right"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  label: "状态",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_switch, {
                    modelValue: scope.row.flag,
                    "onUpdate:modelValue": $event => scope.row.flag = $event,
                    "active-text": "启用",
                    "inactive-text": "禁用",
                    "active-value": 1,
                    "inactive-value": 0,
                    "inline-prompt": "",
                    size: "large",
                    disabled: _unref(readOnly),
                    onChange: $event => skuEnableStateChange($event, scope.$index)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "coupon"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_13]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
                onClick: showAddCouponDialog,
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("添加优惠券")]),
                _: 1
              }), _createVNode(DataCollectTable, {
                ref: "couponItemListTableRef",
                data: basicForm.couponItemList,
                config: couponItemListConfig.value,
                isRoute: false,
                onOperationsHander: _unref(couponItemListHandler).receive,
                isPage: false
              }, null, 8, ["data", "config", "onOperationsHander"])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
                onClick: showAddTagsDialog,
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("添加会员等级")]),
                _: 1
              }), _createVNode(DataCollectTable, {
                ref: "tagsItemListTableRef",
                data: basicForm.tagsItemList,
                config: tagsItemListConfig.value,
                isRoute: false,
                onOperationsHander: _unref(tagsItemListHandler).receive,
                isPage: false,
                disabled: _unref(readOnly)
              }, null, 8, ["data", "config", "onOperationsHander", "disabled"])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
            title: "添加优惠券",
            modelValue: addCouponDialog.value,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => addCouponDialog.value = $event),
            width: "80%",
            "destroy-on-close": ""
          }, {
            footer: _withCtx(() => [_createElementVNode("span", _hoisted_17, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: couponDataSelectedSubmit
            }, {
              default: _withCtx(() => [_createTextVNode("保存")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[18] || (_cache[18] = $event => addCouponDialog.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_form, {
              inline: true,
              class: "base_search_form",
              onSubmit: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: couponName.value,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => couponName.value = $event),
                  "onKeyup[native]": getCouponData,
                  onChange: getCouponData,
                  placeholder: "优惠券名称",
                  clearable: "",
                  "suffix-icon": _unref(Search)
                }, null, 8, ["modelValue", "suffix-icon"])]),
                _: 1
              })]),
              _: 1
            })]), _createVNode(DataCollectTable, {
              ref_key: "couponDataTableRef",
              ref: couponDataTableRef,
              data: couponData.value,
              config: couponDataConfig.value,
              isRoute: false,
              onOperationsHander: _unref(couponDataHandler).receive,
              total: couponDataTotal.value,
              onPageChange: couponDataPageChange
            }, null, 8, ["data", "config", "onOperationsHander", "total"])]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
            title: "添加会员等级",
            modelValue: addTagsDialog.value,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => addTagsDialog.value = $event),
            width: "80%",
            "destroy-on-close": ""
          }, {
            footer: _withCtx(() => [_createElementVNode("span", _hoisted_19, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: tagsDataSelectedSubmit
            }, {
              default: _withCtx(() => [_createTextVNode("保存")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[20] || (_cache[20] = $event => addTagsDialog.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            })])]),
            default: _withCtx(() => [_hoisted_18, _createVNode(DataCollectTable, {
              ref_key: "tagsDataTableRef",
              ref: tagsDataTableRef,
              data: tagsData.value,
              config: tagsDataConfig.value,
              isRoute: false,
              onOperationsHander: _unref(tagsDataHandler).receive,
              isPage: false
            }, null, 8, ["data", "config", "onOperationsHander"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[23] || (_cache[23] = $event => tabChange('spec')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[24] || (_cache[24] = $event => tabChange('basic'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'spec']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[25] || (_cache[25] = $event => tabChange('spec'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'coupon']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[26] || (_cache[26] = $event => tabChange('coupon')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'spec']]), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[27] || (_cache[27] = $event => save(false)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon']]) : _createCommentVNode("", true), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: _cache[28] || (_cache[28] = $event => save(true)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存并提交审核 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon']]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: approvalPass,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批通过")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon' && basicForm.flowStatus == '1007002']]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            onClick: approvalRefusal,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批驳回")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon' && basicForm.flowStatus == '1007002']]) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};